import React from "react";
import { Container, Row, Col, Breadcrumb } from "react-bootstrap";
import { Link } from "react-router-dom";
import Topnav from "../common/Topnav";
import Footer from "../common/Footer";
import bannerImage from "../../Images/Banner/Hostel-banner.webp";
import hostelBuilding from "../../Images/hostel/Hostel building (2).webp";
import hostelGym from "../../Images/hostel/Hostel Gym (1).webp";
import hostelCanteen from "../../Images/hostel/Canteen (2).webp";
import hostelRoom from "../../Images/hostel/Hostel building (2).webp";
import hostelStudy from "../../Images/hostel/Canteen (2).webp";
import hostelLaundry from "../../Images/hostel/Hostel building (3).webp";
import "../../home.css";

const Hostel = () => {
  const hostelFacilities = [
    {
      iconClass: "ti ti-tools-kitchen-2", // Better substitute for "utensils"
      title: "Nutritious Food",
      description:
        "Well-balanced meals prepared with hygiene and nutrition in mind",
    },
    {
      iconClass: "ti ti-droplet", // Alternative to "faucet" for water supply
      title: "24/7 Water Supply",
      description:
        "Round the clock water supply including hot water facilities",
    },
    {
      iconClass: "ti ti-shield-lock", // for campus security
      title: "Campus Security",
      description: "24-hour security with CCTV surveillance for student safety",
    },
    {
      iconClass: "ti ti-stethoscope", // for medical support
      title: "Medical Support",
      description: "Doctor on call and first aid facilities available",
    },
    {
      iconClass: "ti ti-bed", // for comfortable rooms
      title: "Comfortable Rooms",
      description: "Spacious rooms with attached bathrooms and study areas",
    },
    {
      iconClass: "ti ti-wash", // Better substitute for "broom"
      title: "Housekeeping",
      description: "Regular cleaning and maintenance of rooms and common areas",
    },
  ];

  return (
    <React.Fragment>
      <title>Hostel Facilities at ISBM University – Safe & Supportive Living</title>
      <meta
        name="description"
        content="Experience safe and comfortable living at ISBM University hostels with amenities like Wi-Fi, study rooms, nutritious meals, and 24/7 medical assistance."
      />
      <Topnav />
      <section
        className="section-hero-banner ptb-50"
        style={{
          backgroundImage: `linear-gradient(rgba(28,36,71,0.8), rgba(28,36,71,0.8)), url(${bannerImage})`,
        }}
      >
        <div className="banner-hero-overlay">
          <div className="container-xxl">
            <div className="section-hero-content">
              <h1>Hostel Life</h1>
              <ol className="breadcrumb mt-3 text-center mb-0">
                <li className="breadcrumb-item">
                  <Link
                    to="/"
                    style={{ color: "#fff", textDecoration: "none" }}
                  >
                    Home
                  </Link>
                </li>
                <li
                  className="breadcrumb-item active text-white"
                  aria-current="page"
                >
                  Hostel
                </li>
                <hr className="section-divider" />
              </ol>
            </div>
          </div>
        </div>
      </section>
      {/* Hostel Intro */}
      <section className="ptb-50">
        <div className="container-xxl">
          <Row className="align-items-center">
            <Col md={6}>
              <div>
                <h2 className="modern-title section-title-start text-blue">
                  Creating a Nurturing Environment
                </h2>
                <p className="lead">
                  We take special care of all requirements in our hostel for the
                  complete development and growth of every student.
                </p>
                <p>
                  We ensure that each child gets the homely feeling, with the
                  best amenities and the desire to study hard in a friendly
                  atmosphere. Our hygienic environment maintains the good health
                  of students and contributes to their overall physical
                  development.
                </p>
                <p>
                  Students from all over India get exposed to different
                  religions and customs, making our hostel a complete finishing
                  school in itself. We pamper students with amenities while
                  grooming them to manage their routines independently.
                </p>
              </div>
            </Col>
            <Col md={6}>
              <div className="hostel-intro-image shadow-lg rounded overflow-hidden">
                <img
                  src={hostelBuilding}
                  alt="ISBM Hostel Building"
                  className="img-fluid"
                />
              </div>
            </Col>
          </Row>
        </div>
      </section>

      {/* Hostel Features */}
      <section className="hostel-features-section ptb-50">
        <div className="container-xxl">
          <h2 className="section-title text-center modern-title text-white">
            Our Hostel Features
          </h2>
          <h6 className="modern-subtitle text-white text-center">
            At our institute, we provide best hostel facilities to our students.
          </h6>
          <Row className="g-4">
            <Col md={4}>
              <div className="facility-card p-4 h-100 bg-white rounded shadow-sm">
                <div className="facility-icon mb-3 text-primary">
                  <i className="ti ti-home facility-icon-style"></i>
                </div>
                <h4>Home-like Environment</h4>
                <p>
                  We provide all comforts to give students a feeling of being at
                  home while fostering independence.
                </p>
              </div>
            </Col>
            <Col md={4}>
              <div className="facility-card p-4 h-100 bg-white rounded shadow-sm">
                <div className="facility-icon mb-3 text-primary">
                  <i className="ti ti-books facility-icon-style"></i>
                </div>
                <h4>Study-Friendly Atmosphere</h4>
                <p>
                  Spacious rooms with excellent acoustics designed to avoid
                  noise disturbance during study hours.
                </p>
              </div>
            </Col>
            <Col md={4}>
              <div className="facility-card p-4 h-100 bg-white rounded shadow-sm">
                <div className="facility-icon mb-3 text-primary">
                  <i className="ti ti-users facility-icon-style "></i>
                </div>
                <h4>Cultural Exchange</h4>
                <p>
                  Students from diverse backgrounds live together, learning
                  about different cultures and traditions.
                </p>
              </div>
            </Col>
          </Row>
        </div>
      </section>

      {/* Facilities Section */}
      <section className="hostel-facilities-section ptb-50">
        <div className="container-xxl">
          <h2 className="section-title modern-title text-blue text-center">
            Hostel Facilities
          </h2>
          <Row className="g-4">
            {hostelFacilities.map((facility, index) => (
              <Col md={4} key={index}>
                <div className="feature-card p-4 h-100 bg-white rounded shadow-sm">
                  <div className="feature-icon mb-3 text-primary">
                    <i
                      className={`${facility.iconClass} feature-icon-style `}
                    ></i>
                  </div>
                  <h4>{facility.title}</h4>
                  <p>{facility.description}</p>
                </div>
              </Col>
            ))}
          </Row>
        </div>
      </section>

      {/* Gallery Section */}
      <section className="hostel-gallery-section bg-light ptb-50">
        <div className="container-xxl">
          <h2 className="section-title modern-title text-blue text-center">
            Hostel Gallery
          </h2>
          <Row className="g-4">
            <Col md={4}>
              <div className="gallery-item rounded overflow-hidden shadow">
                <img
                  src={hostelRoom}
                  alt="Hostel Room"
                  className="img-fluid w-100"
                />
                <div className="gallery-caption ">
                  <h5 className="mb-0">Comfortable Rooms</h5>
                </div>
              </div>
            </Col>
            <Col md={4}>
              <div className="gallery-item rounded overflow-hidden shadow">
                <img
                  src={hostelStudy}
                  alt="Study Area"
                  className="img-fluid w-100"
                />
                <div className="gallery-caption ">
                  <h5 className="mb-0">Study Areas</h5>
                </div>
              </div>
            </Col>
            <Col md={4}>
              <div className="gallery-item rounded overflow-hidden shadow">
                <img
                  src={hostelGym}
                  alt="Hostel Gym"
                  className="img-fluid w-100"
                />
                <div className="gallery-caption ">
                  <h5 className="mb-0">Fitness Center</h5>
                </div>
              </div>
            </Col>
            <Col md={6}>
              <div className="gallery-item rounded overflow-hidden shadow">
                <img
                  src={hostelCanteen}
                  alt="Hostel Canteen"
                  className="img-fluid w-100"
                />
                <div className="gallery-caption">
                  <h5 className="mb-0">Dining Facility</h5>
                </div>
              </div>
            </Col>
            <Col md={6}>
              <div className="gallery-item rounded overflow-hidden shadow">
                <img
                  src={hostelLaundry}
                  alt="Hostels"
                  className="img-fluid w-100"
                />
                <div className="gallery-caption ">
                  <h5 className="mb-0">Hostels</h5>
                </div>
              </div>
            </Col>
          </Row>
        </div>
      </section>

      {/* Discipline Section */}
      <section className="hostel-discipline-section ptb-50">
        <div className="container-xxl">
          <Row className="align-items-center">
            <Col md={6}>
              <div className="discipline-image shadow-lg rounded overflow-hidden">
                <img
                  src={hostelBuilding}
                  alt="Hostel Discipline"
                  className="img-fluid"
                />
              </div>
            </Col>
            <Col md={6}>
              <div className="discipline-content">
                <h2 className="modern-title section-title-start text-blue">Discipline & Hygiene</h2>
                <p className="lead">
                  Liberal in all means, but strict in maintaining hygiene,
                  manners, and discipline.
                </p>
                <p>
                  We lessen the burden of daily chores with in-house staff who
                  take care of washing, ironing, and regular room cleaning.
                  However, we emphasize personal responsibility and time
                  management skills.
                </p>
                <ul className="list-unstyled">
                  <li className="mb-2">
                    <i className="ti ti-circle-check text-blue me-2"></i>
                    Regular room inspections
                  </li>
                  <li className="mb-2">
                    <i className="ti ti-circle-check text-blue me-2"></i>
                    Strict hygiene standards
                  </li>
                  <li className="mb-2">
                    <i className="ti ti-circle-check text-blue me-2"></i>
                    Curfew timings for safety
                  </li>
                  <li className="mb-2">
                    <i className="ti ti-circle-check text-blue me-2"></i>
                    Study hours enforcement
                  </li>
                </ul>
              </div>
            </Col>
          </Row>
        </div>
      </section>

      <Footer />
    </React.Fragment>
  );
};

export default Hostel;
